import { render, staticRenderFns } from "./ShiftsWrapper.vue?vue&type=template&id=78a146c6&scoped=true&"
import script from "./ShiftsWrapper.vue?vue&type=script&lang=js&"
export * from "./ShiftsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a146c6",
  null
  
)

export default component.exports